import type { EntitlementDetails } from '@atlassian/jira-shared-types/src/tenant-context.tsx';
import { useTenantContext } from '../tenant-context/index.tsx';

export const useProductEntitlementDetails = (): Record<string, EntitlementDetails> | null => {
	const tenantContext = useTenantContext();
	return (tenantContext && tenantContext.productEntitlementDetails) || null;
};
